<template>
  <div>
    <div class="card">
      <div class="content">
        <div>
          <div class="justify-text msg_list">
            <div class="cell_title"><svg-icon class-name="zl-icon iconfont" icon-class="orderMsg"></svg-icon>基本信息</div>
            <div class="cell">
              <div class="li">寝室</div>
              <span class="licontent">{{detail.FullAddress }}</span>
            </div>
            <div class="cell">
              <div class="li">校区</div>
              <span class="licontent">{{detail.RegionName }}</span>
            </div>
            <div class="cell">
              <div class="li">下单人</div>
              <span class="licontent">{{detail.Name }}</span>
            </div>
            <div class="cell">
              <div class="li">下单手机</div>
              <span class="licontent">{{detail.Mobile}}</span>
            </div>
            <div class="cell">
              <div class="li">学历</div>
              <span class="licontent">{{detail.Education }}</span>
            </div>
            <div class="cell">
              <div class="li">年级</div>
              <span class="licontent">{{detail.Grade }}</span>
            </div>
            <div class="cell">
              <div class="li">专业</div>
              <span class="licontent">{{detail.Major }}</span>
            </div>
          </div>
          <div class="justify-text msg_list">
            <div class="cell_title"><svg-icon class-name="zl-icon iconfont" icon-class="setMeal"></svg-icon>套餐信息</div>
            <div class="cell">
              <div class="li">套餐名称</div>
              <span class="licontent">{{detail.PackageName }}</span>
            </div>
            <div class="cell">
              <div class="li">租金</div>
              <span class="licontent">{{detail.Price }}</span>
            </div>
            <div class="cell">
              <div class="li">押金</div>
              <span class="licontent">{{detail.Deposit }}</span>
            </div>
            <div class="cell">
              <div class="li">到期时间</div>
              <span class="licontent">{{detail.EndTimeStr }}</span>
            </div>
          </div>
          <div class="msg_list">
            <div class="cell_title"><svg-icon class-name="zl-icon iconfont" icon-class="payMsg"></svg-icon>支付信息
              <wx-pay pay-url="/BizMemberAdvance/AdvancePay" v-if="(detail.Status === '待支付' || detail.Status === '支付中') && detail.IsOnline" :params="{ Id: detail.Id }" class="pay" style="margin-left: 10px;" @successPay="successPay" @refresh="refresh">
                支付
              </wx-pay>
            </div>
            <div class="cell">
              <div class="li">支付状态</div>
              <span class="licontent" :style="detail.Status === '待支付'? 'color: #ef941b;': detail.Status === '已取消' ? 'color: #909399;': 'color: #07c160;'">{{ detail.Status }}
              </span>
            </div>
            <div class="cell">
              <div class="li">支付时间</div>
              <span class="licontent">{{detail.PayTimeStr }}</span>
            </div>
            <div class="cell">
              <div class="li">支付金额</div>
              <span class="licontent">￥{{detail.Money }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import trSteps from "@/components/trSteps";
import { setCookie } from "@/utils/cookie";

export default {
  name: "advanceDeatils",
  data() {
    return {
      detail: {},
      payParams: {}
    };
  },
  components: {
    trSteps,
  },
  methods: {
    successPay(val) {
      this.$toast.loading().clear()
      if(val === 'chooseWXPay:ok') {
        this.$dialog.alert({
          message: '订单支付成功！'
        }).then(() => {
        })
      } else {
        this.$toast.fail('支付失败！');
      }
    },
    refresh(){
      this.getDetail();
    },
    getDetail() {
      let url = "/BizMemberAdvance/Details";
      // this.$toast.loading({
      //   duration: 1000,
      //   mask: true,
      //   message: "加载中...",
      // });
      this.$post(url, { Id: this.$route.query.Id }).then((res) => {
        if (res) {
          this.detail = res.Data;
        }
      });
    }
  },
  mounted() {
    this.getDetail();
  },
};
</script>

<style scoped lang="less">
.card {
  margin: 15px;
  .content {
    .van-cell__value {
      min-width: 70%;
      color: black;
    }
  }
  .rightButton {
    display: flex;
    align-items: center;
  }
}
.msg_list{
  padding:10px 20px;
  background:#fff;
  border-radius: 10px;
  margin:10px 0;
  .cell_title{
    font-size:18px;
    color:#303133;
    font-weight: bold;
    margin:5px 0 10px 0;
    padding-bottom:15px;
    border-bottom: 1px solid #eee;

    svg{
      margin-right: 5px;
      font-size:28px;
    }
  }
   .cell{
     display: flex;
     justify-content: space-between;
     margin: 20px 0;
     color:#303133;
     .li{
       color:#999;
       font-size: 16px;
     }
     .licontent{
       font-size:16px;
     }
   }
}
.user-info {
  margin-bottom: 10px;
  display: flex;
  background: #fff;
  padding: 10px;
  position: relative;
  .Headimg {
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
    font-size: 16px;
    width: 45px;
    height: 45px;
    margin-right: 10px;
    img {
      width: 110%;
    }
  }
  time {
    position: absolute;
    right: 10px;
    top: 13px;
    color: #999;
    font-size: 14px;
  }
  .info {
    p {
      margin: 0;
      font-size: 14px;
      margin-bottom: 5px;
      strong {
        margin-left: 5px;
        font-size: 12px;
        font-weight: normal;
        color: #999;
      }
    }
    div {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 14px;
      color: #999;
      strong {
        font-weight: normal;
        font-size: 18px;
        color: #666;
      }
    }
  }
}
.pay-type {
  background: #468bea;
  height: 80px;
  font-size: 20px;
  color: #fff;
  padding: 10px;
  p {
    font-size: 12px;
    margin: 0;
    margin-top: 10px;
  }
}
.status-style {
  background-color: #909399 !important;
}
.Remarks {
  margin-top: 15px;
  background: #fff;
  p {
    margin: 0;
    padding: 10px 15px;
  }
  > div {
    padding: 0 15px 10px 15px;
    color: #666;
  }
}

.pay{
  width: 50px;
  display: inline-block;
  height: 30px;
  float: right;
  box-sizing: border-box;
  border-radius: 6px;
  background-color: #00d8a0;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
  z-index: 1000;
}
</style>
